import { PayloadAction } from '@reduxjs/toolkit';

import { FontDefinition, FontState } from 'editor/src/store/fonts/types';

const setFontListReducer = (state: FontState, action: PayloadAction<FontDefinition[]>) => {
  state.availableFonts = action.payload;
};

export default setFontListReducer;
